export enum bahai_inquiry_typecode {
  TalkToABahai = 200630000,
  RequestFreeLiterature = 200630001,
  ENewsLetterSignUp = 200630002,
  BecomeaBahai = 200630003,
}

export enum statecode {
  Active = 0,
  Inactive = 1,
}

export enum statuscode {
  Inactive = 2,
  New = 1,
}

export enum bahai_inquirystatus {
  Concluded = 200630002,
  InProgress = 200630001,
  New = 200630000,
}

export enum bahai_prioritycode {
  Low = 200630000,
  Medium = 200630001,
  High = 200630002,
  Very_High = 200630003,
}
